// extracted by mini-css-extract-plugin
module.exports = {"container":"home-display-collection-new-arrivals_container__TXWwN"};